import React from "react";
import styles from "./ColumnsLayout.module.scss";
/**
 * Component Props
 * @param {children} props
 * @param {number[]} sizes
 */

const distribute = (sizes) => (component, index) => component
  // (
  //   <div >
  //     {component}
  //   </div>
  // );

const ColumnsLayout = (props) => (
  <div className={styles.root}>
    {props.children.map(distribute(props.sizes))}
  </div>
);

export default ColumnsLayout;

